import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";

/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import classNames from "classnames";
import * as React from "react";
import { NavLink, OverlayTheme, OverlayType } from "..";
import NavItem from "./NavItem";
import "./scss/index.scss";

var NavDropdown =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(NavDropdown, _React$PureComponent);

  function NavDropdown() {
    var _getPrototypeOf2;

    var _temp, _this;

    _classCallCheck(this, NavDropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(NavDropdown)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
      active: false
    }, _this.showOverlayHandler = function () {
      if (_this.hasSubNavigation) {
        _this.setState({
          active: true
        });

        _this.props.overlay.show(OverlayType.mainMenuNav, OverlayTheme.modal);
      }
    }, _this.hideOverlayHandler = function () {
      if (_this.state.active) {
        _this.props.overlay.hide();

        _this.setState({
          active: false
        });
      }
    }, _temp));
  }

  _createClass(NavDropdown, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var children = this.props.children;
      children.map(function (i) {
        i.subCatergory = true;
        i.parentName = _this2.props.name;
      });
      var active = this.state.active;
      var showDropDown = active && this.hasSubNavigation;
      return React.createElement("ul", {
        className: classNames({
          "main-menu__nav-dropdown": true,
          "main-menu__nav-dropdown--active": showDropDown
        }),
        onMouseOver: this.showOverlayHandler,
        onMouseLeave: this.hideOverlayHandler
      }, React.createElement("li", null, React.createElement(NavLink, {
        item: this.props,
        onClick: this.hideOverlayHandler
      })), React.createElement("li", {
        className: classNames({
          "main-menu__nav-dropdown__body": true,
          "main-menu__nav-dropdown__body--visible": showDropDown
        })
      }, React.createElement("ul", null, children.map(function (subItem, i) {
        return React.createElement(NavItem, _extends({
          key: i,
          hideOverlay: _this2.hideOverlayHandler
        }, subItem));
      }))));
    }
  }, {
    key: "hasSubNavigation",
    get: function get() {
      var children = this.props.children;
      return children && !!children.length;
    }
  }]);

  return NavDropdown;
}(React.PureComponent);

export default NavDropdown;